module.exports = __webpack_public_path__ + "static/media/step4.c7114cd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/step4.jpg
// module id = 772
// module chunks = 0